import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChapaComponent } from './chapa.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    TranslocoModule
  ],
  declarations: [
    ChapaComponent
  ],
  exports: [ChapaComponent]
})
export class ChapaModule { }
